import Emitter from "es6-event-emitter";

import imagegalleryslide from "./../templates/imagegalleryslide.dust";

import { isHTML } from "./../utilities/utils";

import { CLICKED_CAPTION_GALLERY } from "./../analytics/analyticsevents";

export default class ImageGallerySlide extends Emitter {
  appState = null;
  image = null;
  options = null;

  DOMContainer = null;

  caption = null;

  onlyFirstLines = null;

  _slideCounter = 0;

  contentItemId = null;

  constructor(appState, image, options) {
    super();
    this.appState = appState;
    this.image = image;
    this.options = options;
  }

  render() {
    const resultPromise = new Promise((resolve, reject) => {
      const promiseData = {};
      promiseData.reject = reject;
      promiseData.resolve = resolve;
      this.DOMContainer = document.createElement("div");
      this.DOMContainer.classList.add("swiper-slide");
      this.DOMContainer.classList.add("swiper-slide-imageviewer");
      const context = this.image;
      this.onlyFirstLines =
        this.options.imageViewerCaptionOnlyFirstLines &&
        !isHTML(this.image.HtmlText);
      context.captionOnlyFirstLines = this.onlyFirstLines;
      context.desktop = this.appState.isDesktop;
      this._generateImageIdentifier(context);
      Dust.render(imagegalleryslide, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.caption = this.DOMContainer.querySelector(".imageviewer-caption");
        this.attatchClickHandlers();
        if (this.appState.isDesktop && this.options.loopSwiper) {
          this._loadImage(context).then(() => {
            promiseData.resolve(this.DOMContainer);
          });
        } else {
          promiseData.resolve(this.DOMContainer);
          this._loadImage(context);
        }
      });
    });
    return resultPromise;
  }

  _generateImageIdentifier(context) {
    context.imageIdentifier = "imgSlide_" + this._slideCounter;
    context.hDImageIdentifier = "hDImgSlide_" + this._slideCounter;
    this._slideCounter++;
  }

  _loadImage(galleryimage) {
    this.contentItemId = galleryimage.ContentItemId || galleryimage.Id;
    const element = this.DOMContainer.querySelector(
      "." + galleryimage.imageIdentifier
    );
    if (this.appState.isDesktop) {
      return this.appState.cdnAssetsDownloader.loadImageOnElement(
        this.options.sizes.HD,
        this.contentItemId,
        element,
        false,
        true
      );
    } else {
      element.classList.add("hidden");
      return this.appState.cdnAssetsDownloader
        .loadImageOnElement(
          this.options.sizes.nonHD,
          this.contentItemId,
          element,
          true,
          false
        )
        .then((ratio) => {
          element.classList.remove("hidden");
          this.initHammerSlide(ratio);
        });
    }
  }

  renderHd() {
    if (!this.hd) {
      const hdElement = this.DOMContainer.querySelector(
        ".slide-imageviewer.hd"
      );
      if (this.appState.isDesktop) {
        this.appState.cdnAssetsDownloader.loadImageOnElement(
          this.options.sizes.HD,
          this.contentItemId,
          hdElement,
          false,
          true
        );
      } else {
        this.appState.cdnAssetsDownloader.loadImageOnElement(
          this.options.sizes.HD,
          this.contentItemId,
          hdElement,
          false,
          false
        );
      }
      this.hd = true;
    }
  }

  attatchClickHandlers() {
    if (this.onlyFirstLines && this.caption) {
      this.caption.addEventListener("click", (e) => {
        this.captionClicked(e);
      });
    }
  }

  captionClicked(e) {
    if (this.onlyFirstLines && this.caption) {
      e.preventDefault();
      if (this.caption.classList.contains("maxlines")) {
        this.openCaption();
      } else {
        this.closeCaption();
      }
    }
    this.appState.triggerEvent(CLICKED_CAPTION_GALLERY);
  }

  openCaption() {
    if (this.caption) {
      this.caption.classList.remove("maxlines");
      this.caption.classList.add("maxHeight");
    }
  }

  closeCaption() {
    if (this.caption) {
      this.caption.classList.remove("maxHeight");
      this.caption.classList.add("maxlines");
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/imageGallerySlide.js